document.addEventListener("click", function (event) {
  var button = event.target.closest(".oz-trade-faqs__question");
  if (!button) return;
  var item = button.closest(".oz-trade-faqs__item");
  if (!item) return;
  var open = item.classList.contains("is-open");
  var list = item.parentElement;
  if (list) {
    list.querySelectorAll(".oz-trade-faqs__item.is-open").forEach(function (el) {
      el.classList.remove("is-open");
      var btn = el.querySelector(".oz-trade-faqs__question");
      var icon = el.querySelector(".oz-trade-faqs__icon");
      if (btn) btn.setAttribute("aria-expanded", "false");
      if (icon) icon.textContent = "+";
    });
  }
  if (!open) {
    item.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    var plus = item.querySelector(".oz-trade-faqs__icon");
    if (plus) plus.textContent = "−";
  }
});
